/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_No_TablesInputs */



/**
* | output |
* | --- |
* | "No tables yet. Create one to get started." |
*
* @param {Datasets_No_TablesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_no_tables = /** @type {((inputs?: Datasets_No_TablesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_No_TablesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Tabellen. Erstellen Sie eine, um zu beginnen.")
	return /** @type {LocalizedString} */ ("No tables yet. Create one to get started.")
});